import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'

/**
 * returns whether the corresponding button should be visible and enabled
 * based on the capabilities, feature flag, and the current state
 * - button `visible` if one of the `capabilities` is enabled and the FF is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfHandRaiseButtonState = () => {
  const selfHandRaised = useSelfMemberState({
    subscriptionKey: 'handRaised',
  })
  const selfHandRaiseCapabilityOff = useCapabilitiesStore(
    state => state.selfHandRaiseCapabilityOff,
  )
  const selfHandRaiseCapabilityOn = useCapabilitiesStore(
    state => state.selfHandRaiseCapabilityOn,
  )
  const isFeatureDisabled = useFeaturesStore(
    state => state.disabled.ROOM_RAISE_HAND === FEATURES.ROOM_RAISE_HAND,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isRaiseHandButtonVisible =
    !isFeatureDisabled &&
    (selfHandRaiseCapabilityOn || selfHandRaiseCapabilityOff)

  const canRaiseHand = !selfHandRaised && selfHandRaiseCapabilityOn
  const canExitRaiseHand = selfHandRaised && selfHandRaiseCapabilityOff

  // check if button can perform the necessary next action
  const isRaiseHandButtonEnabled = canRaiseHand || canExitRaiseHand

  return { isRaiseHandButtonEnabled, isRaiseHandButtonVisible }
}
